import { render, staticRenderFns } from "./TyrelifeReport.vue?vue&type=template&id=64be2f6e&scoped=true&"
import script from "./TyrelifeReport.vue?vue&type=script&lang=js&"
export * from "./TyrelifeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be2f6e",
  null
  
)

export default component.exports